import { render, staticRenderFns } from "./StockRelateTask.vue?vue&type=template&id=cb554e76&"
import script from "./StockRelateTask.vue?vue&type=script&lang=js&"
export * from "./StockRelateTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports